import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ExpressionCondition } from '@/models/audiences';
import { IRuleProps } from './types';
import { RuleValue, TraitValue } from '.';
import PropertyRuleIcon from '../../../../assets/icons/rule-which-property-is.svg?react';
import { PROPERTY_OPERATIONS_LABEL_MAPPER } from '@/features/audienceEdit_v2/constants';

type PROPERTY_OPERATIONS_LABEL_MAPPER_KEY = keyof typeof PROPERTY_OPERATIONS_LABEL_MAPPER;

const createComparisonOptions = (operations: string[]) => {
  return operations.map((operation) => ({
    id: operation,
    label: PROPERTY_OPERATIONS_LABEL_MAPPER[operation as PROPERTY_OPERATIONS_LABEL_MAPPER_KEY] || operation,
  }));
};

export const PropertyRule: FC<IRuleProps> = ({ expression, propertyOperations }) => {
  const { t: tAudience } = useTranslation('audience');

  const [TEXT_COMPARISON_OPS, NUMBER_COMPARISON_OPS, DATE_COMPARISON_OPS] = useMemo(() => {
    return [
      createComparisonOptions(propertyOperations?.TEXT.operations || []),
      createComparisonOptions(propertyOperations?.NUMBER.operations || []),
      createComparisonOptions(propertyOperations?.DATE.operations || []),
    ];
  }, [propertyOperations]);

  const retrieveComparisonOp = (expression: ExpressionCondition) => {
    switch (expression.dataType) {
      default:
      case 'TEXT':
        return TEXT_COMPARISON_OPS;
      case 'NUMBER':
        return NUMBER_COMPARISON_OPS;
      case 'DATE':
        return DATE_COMPARISON_OPS;
    }
  };

  const comparisonOperator = useMemo(() => retrieveComparisonOp(expression).find((o) => o.id === expression.comparisonOp), [expression]);

  return (
    <div className='flex flex-col gap-1.5'>
      <div className='flex gap-2 text-sm font-medium text-tertiary-600'>
        <PropertyRuleIcon className='text-brand-500' />
        <TraitValue traitId={expression.property} />
      </div>
      {comparisonOperator && (
        <div className='flex items-center gap-1.5'>
          {comparisonOperator.doNotRenderValue ? (
            <RuleValue>{String(tAudience(comparisonOperator.label as any))}</RuleValue>
          ) : (
            <>
              <p className='text-xs font-medium text-tertiary-600'>{String(tAudience(comparisonOperator.label as any))}</p>
              <RuleValue>{expression.value}</RuleValue>
            </>
          )}
        </div>
      )}
    </div>
  );
};
